import React, { useEffect, useState } from "react";
import Header from "./Header";
import { useDispatch, useSelector } from "react-redux";
import { getMates, allMates } from "./redux/reducer/getMates";
import Swal from "sweetalert2";
import ring from "./img/anillo.png";
import husband from "./img/marido.png";
import wife from "./img/esposa.png";
import { images } from "./images";
import Documents from "./Document";
import { PDFDownloadLink } from "@react-pdf/renderer";

const Home = () => {
  let date = new Date();
  let now = Date.now();
  console.log(now);
  let day = date.getDay();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  let fecha =
    month < 10 ? `${day}/0${month}/${year}` : `${day}/${month}/${year}`;
  const dispatch = useDispatch();
  const [available, setAvailable] = useState(false);
  const [datos, setDatos] = useState({
    petitioner: "",
    fiance: "",
    fecha: fecha,
  });
  const onChange = (e) => {
    setDatos({ ...datos, [e.target.name]: e.target.value });
  };
  const marry = (e) => {
    localStorage.setItem("data", JSON.stringify(datos));
    setDatos({
      petitioner: "",
      fiance: "",
      fecha: fecha,
    });
    document.getElementById("petitioner").value = "";
    document.getElementById("fiance").value = "";
    Swal.fire({
      icon: "success",
      text: "Datos guardados, se descargará un PDF como comprobante",
    }).then((result) => {
      let button = document.getElementById("button-download");
      setAvailable(true);
      button.classList.remove("noView");
      button.classList.add("button-download");
    });
  };
  const desactivateButton = (e) => {
    setAvailable(false);
  };
  /*useEffect(() => {
    dispatch(getMates());
  }, [dispatch]);*/
  console.log(datos);

  return (
    <div className="content-mother">
      <Header />
      <div className="content">
        <div className="listInputs">
          <div className="inputEnter">
            <img src={husband} alt="husband" width={60} height={60} />
            <input
              type="text"
              className="inputWeed"
              id="petitioner"
              name="petitioner"
              placeholder="Ingrese nombre"
              onChange={onChange}
            />
          </div>
          <div>
            <img src={ring} alt="heart" width={100} height={100} />
          </div>
          <div className="inputEnter">
            <img src={wife} alt="wife" width={60} height={60} />
            <input
              type="text"
              id="fiance"
              className="inputWeed"
              name="fiance"
              placeholder="Ingrese nombre"
              onChange={onChange}
            />
          </div>
        </div>{" "}
        <div className="button-content">
          <button
            disabled={
              datos.petitioner.length === 0 || datos.fiance.length === 0
            }
            onClick={marry}
            className="button-marry"
          >
            Casarnos
          </button>
          <PDFDownloadLink
            document={<Documents />}
            fileName="certicado-matrimonio.pdf"
          >
            <button
              onClick={desactivateButton}
              id="button-download"
              className="noView"
              disabled={!available}
            >
              Descargar PDF
            </button>
          </PDFDownloadLink>
        </div>
        <div className="iconImages">
          {images.map((image) => (
            <img
              src={image.url}
              alt="weed"
              width={150}
              height={150}
              className="weedImages"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
